const data = {
  data: [
    { title: '纺织行业', type: 'textile-industry', img: '/images/case/m-fz.jpg' },
    { title: '汽车行业', type: 'motor-dom', img: '/images/case/m-qc.jpg' },
    { title: '跨境行业', type: 'cross-border', img: '/images/case/m-kj.jpg' },
    { title: '玻璃行业', type: 'glass-industry', img: '/images/case/m-bl.jpg' },
    { title: 'MRO行业', type: 'mro', img: '/images/case/m-mro.jpg' },
    { title: '零售电商行业', type: 'retail-e-commerce', img: '/images/case/m-ls.jpg' },
    { title: '塑料包装行业', type: 'plastic-packaging', img: '/images/case/m-sl.jpg' },
  ]
}

export default data